import React from "react";

const LiveModalContext = React.createContext();

export default LiveModalContext;
